import React, { useState } from 'react';
import { getCarImage } from '../module/api_init';
import { getComaPrice, makespaceline } from '../module/simple';
import LocationBasedPrice from './location_based_car_price';

function HomeFindCar({ props }) {
  // const [state, setState] = useState(props.state.enquiryPopup)
    const [pageM, setpageM] = useState(0);
    const [page, setpage] = useState(0);

  
    const { findCars, location } = props.state;
    const selctedTypeStyle = {
        color: '#00afa0',
        fontWeight: 'bold',
    };

    return (
        <div className="hb_1a" id="hm_b">
            <div className="hb_1d" />
            <div className="hb_1b">
                <div className="hb_1b_a"> Choose Your Car </div>
                <button
                    className="hb_1b_b"
                    onClick={() =>
                        (window.location = '/allcars/' + location.id ?? 0)
                    }
                >
                    VIEW ALL CARS
                </button>
            </div>
            <div className="hb_1b"></div>
            <div className="hb_1b1">
                <div className="hb_1b2">
                    {findCars.map((tab, k) => (
                        <div
                            key={k}
                            className="hb_1b2a"
                            onClick={() => {
                                setpageM(k);
                                setpage(0);
                            }}
                        >
                            <div
                                className="hb_1b3"
                                style={pageM === k ? selctedTypeStyle : {}}
                            >
                                {tab.title}
                            </div>

                            <div
                                className="hb_1b3a"
                                style={{
                                    visibility: pageM === k ? null : 'hidden',
                                }}
                            />
                        </div>
                    ))}
                </div>
                <div className="hb_1b2b" />
                <div className="hb_1b2">
                    {findCars[pageM].cat.map((tab, k) => (
                        <div
                            key={k}
                            className="hb_1b2a"
                            onClick={() => setpage(k)}
                        >
                            <div
                                className="hb_1b3a"
                                style={{
                                    visibility: page === k ? null : 'hidden',
                                }}
                            />
                            <div
                                className="hb_1b3"
                                style={page === k ? selctedTypeStyle : {}}
                            >
                                {tab.title}
                                {/* {tab.title == "Manual/Automatic" ? (
                  <div>
                    <div className="hb_1b2">Automatic</div>
                  </div>
                ) : tab.title == "Petrol/CNG" ? (
                  <div>
                    <div className="hb_1b2">CNG</div>
                  </div>
                ) : (
                  tab.title
                )} */}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="hb_8a">
                    {findCars[pageM].cat[page].cars.map((item, k) => (
                        <div key={k} className="hb_8c">
                            <div
                                className="hb_8d"
                                onClick={() =>
                                    (window.location =
                                        '/allcars/0/0/' +
                                        makespaceline(item.model.title))
                                }
                            >
                                <img
                                    className="hb_8e"
                                    src={getCarImage(item.images[0].images)}
                                    alt="Kalyanimotors Leading Maruti Suzuki Dealership"
                                />
                            </div>
                            <div className="hb_8f">
                                <div className="hb_8j">{item.model.title}</div>
   
                                <LocationBasedPrice item={item} />
                                	
                                {window.innerWidth < 600 ? (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: 9,
                                                background: '#047A70',
                                                width: '48%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white',
                                                fontWeight: '500',
                                                borderRadius: 10,
                                                height: 20,
                                                marginTop: 4,
                                            }}
                                            onClick={() =>
                                                window.location.assign(
                                                    'tel:' +
                                                        (location.phone_number ??
                                                            '')
                                                )
                                            }
                                        >
                                            Call Now
                                        </div>
                                        <div
                                            style={{
                                                fontSize: 9,
                                                background: '#2E3192',
                                                width: '48%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white',
                                                fontWeight: '500',
                                                borderRadius: 10,
                                                height: 20,
                                                marginTop: 4,
                                            }}
                                            onClick={() =>
                                                props.setState({
                                                    enquiryPopup: {
                                                        car: item.name,
                                                        type: 0,
                                                    },
                                                })
                                            }
                                        >
                                            Get Best Price
                                        </div>
                                    </div>
                                ) : (
                                    <React.StrictMode>
                                        <div
                                            className="hb_8i"
                                            onClick={() =>
                                                props.setState({
                                                    enquiryPopup: {
                                                        car: item.name,
                                                        item:item,
                                                        type: 0,
                                                    },
                                                })
                                            }
                                        >
                                            Show On-Road Price
                                        </div>
                                        <div
                                            className="hb_8i_1"
                                            onClick={() =>
                                                props.setState({
                                                    enquiryPopup: {
                                                        car: item.name,
                                                        item:item,
                                                        type: 6,
                                                    },
                                                })
                                            }
                                        > 
                                            Get Best Offers
                                        </div>
                                    </React.StrictMode>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default HomeFindCar;
